import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Nft() {
    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>NFTS</span>
                    </div>
                </section>


                <section class="pad bank-benefits default margin-top-content">

                    <div class="content normal">
                        <div data-lavalamp=""></div>

                        <div class="img-frame">
                            <img src="images/nugenesisou/pr-illustration-22.png" alt="" />
                        </div>

                        <div class="data">
                            <div class="text">
                                <h3 class="title">NFTS?</h3>

                                <p class="subtitle">
                                    What are NFTs their benefits, Uses types and Implementation in the Nugenesis Network?
                                </p>

                            </div>
                            <div class="btns">
                                <a href="document/What-is-an-NFT.pdf" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div>
                            <br></br>
                            <div class="text">

                                <p class="subtitle">
                                    Nugenesis proposes a benefit of
                                    having a 'slice of the action' in the
                                    NFT Realm using the Nugenesis
                                    Network, ecosystem and
                                    technological innovations.
                                </p>

                            </div>
                            {/* <div class="btns">
                                <a href="https://www.dropbox.com/scl/fo/xbbfcs0xn7vmoqg0q76zb/h?rlkey=hl7cq79dlgu0e4ega921u6ofl&e=1&dl=0" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div> */}
                        </div>


                    </div>

                </section>





            </main>
            <Footer />
        </>
    )
}